import { forwardRef } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const ExportArrow01Linear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.44 8.90039C20.04 9.21039 21.51 11.0604 21.51 15.1104V15.2404C21.51 19.7104 19.72 21.5004 15.25 21.5004H8.73998C4.26998 21.5004 2.47998 19.7104 2.47998 15.2404V15.1104C2.47998 11.0904 3.92998 9.24039 7.46998 8.91039"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 15.0001V3.62012" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.3499 5.85L11.9999 2.5L8.6499 5.85" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
});
